/**
 * tabs v1.0.3
 */

import Component, { nextTick } from "../../js/lib/component";
import Scroll from "../../js/lib/scroll";
import Cookie from "../../js/lib/cookie";
import Page from "../page/page";
import $ from "jquery";
import anime from "animejs";

const classList = {
  root: ".js-tabs",
  tab: ".js-tabs-item",
  label: ".js-tabs-label",
  toggle: ".js-tabs-toggle",
  section: ".js-tabs-section"
};

export default class Tabs extends Component {
  init() {
    const options = this.$.root.data();

    this.options = {
      hash: "hash" in options ? options.hash : true,
      autoscroll: "autoscroll" in options ? options.autoscroll : true,
      cookieName: "cookieName" in options ? options.cookieName : false
    };

    if (!this.href && this.options.cookieName) {
      const tabInCookie = Cookie.get(`tabs_${this.options.cookieName}`);
      this.href = tabInCookie ? tabInCookie : "";
    }

    this.isAccordion = this.$.root.is(".is-accordion");
    this.setPageTriggers();

    nextTick().then(() => {
      this.render();
    });
  }
  setPageTriggers() {
    this.$.trigger = $(
      this.$.label
        .map((i, label) => {
          return $(`[href='${label.getAttribute("href")}'`);
        })
        .toArray()
        .reduce((acc, label) => {
          return [...acc, ...label];
        }, [])
        .filter(label => {
          return !$(label).is(classList.label);
        })
    );
  }
  render() {
    this.$.tab.hide();
    this.setActive();
    this.set({ init: true });
    this.$.root.addClass("is-inited");
  }
  events() {
    this.$.label.on("click.tabs", e => {
      e.stopPropagation();
      this.handler(e);
    });

    this.$.toggle.on("click.tabs", e => {
      e.stopPropagation();
      this.toggle(e);
    });

    this.$.trigger.on("click.tabs", e => {
      e.preventDefault();

      if (this.isAccordion && this.$.window.width() < Page.breakpoint.l) {
        const $target = $(e.currentTarget);
        const href = $target.attr("href");
        const $tab = this.$.tab.filter(href);

        this.href = "";

        $tab.addClass("is-visible");

        if (this.options.autoscroll) {
          Scroll.to($tab);
        }
      } else {
        this.handler(e);
        if (this.options.autoscroll) {
          Scroll.to(this.$.root);
        }
      }
    });
  }
  toggle(e) {
    e.preventDefault();

    const $target = $(e.currentTarget);
    const $tab = $target.closest(this.$.tab);
    const isVisible = $tab.is(".is-visible");
    const action = isVisible ? "removeClass" : "addClass";

    $tab[action]("is-visible");
  }
  handler(e, target) {
    e.preventDefault();

    if (this.state.animating) return;

    const $target = target || $(e.currentTarget);
    const href = $target.attr("href");

    this.href = href;
    this.setActive();
  }
  setActive() {
    this.setLabel();
    this.setTab();
  }
  setLabel() {
    this.$.label.removeClass("is-active");
    this.$.label.attr("tabindex", -1);

    if (this.$.label.is(".is-focused")) {
      this.$.document.trigger("focus", {
        $trigger: this.$selectedLabel
      });
    }

    this.$selectedLabel.removeAttr("tabindex");
    this.$selectedLabel.addClass("is-active");
  }
  setTab() {
    const $current = this.$currentTab;
    const $next = this.$selectedTab;

    if ($current.length) {
      this.toggleTab($current, $next);
      this.setActiveFilter($next, $current);
    } else {
      $next.addClass("is-active");
      $next.show();
      this.setActiveFilter($next);
    }
  }
  setActiveFilter($next, $current) {
    if ($current) {
      this.setFilterComponentState($current, false);
    }

    this.setFilterComponentState($next);
  }
  setFilterComponentState($node, active = true) {
    const $filter = $node.find(".js-filter");

    if ($filter.length && $filter[0].component) {
      const filter = $filter[0].component;

      if (filter) {
        filter.setState({ active });
      }
    }
  }
  toggleTab($current, $next) {
    this.fixHeight();

    this.state.animating = true;

    anime({
      targets: $current.get(0),
      opacity: 0,
      translateX: 20,
      easing: "easeInCubic",
      duration: 300,
      complete: () => {
        $current.removeClass("is-active").css("display", "none");
        $next.addClass("is-active").css({
          display: "block",
          opacity: 0,
          transform: "translateX(-20px)"
        });

        this.updateHeight();

        anime({
          targets: $next.get(0),
          opacity: 1,
          translateX: 0,
          easing: "easeOutCubic",
          duration: 300,
          complete: () => {
            this.handleFilter($current);
            this.reInitScrollbars();
            this.state.animating = false;
          }
        });
      }
    });
  }
  reInitScrollbars() {
    const scrollbars = this.childs("Scrollbar");

    if (scrollbars.length) {
      scrollbars.forEach(scrollbar => {
        scrollbar.reInit();
      });
    }
  }
  handleFilter($tab) {
    const $filter = $tab.find(".js-filter");

    if ($filter.length) {
      try {
        $filter
          .get(0)
          .component.$.root.get(0)
          .reset();
      } catch (e) {}
    }
  }
  set href(hash) {
    if (this.options.hash) {
      // location.hash = href;
      history.pushState(
        null,
        null,
        `${location.origin}${location.pathname}${
          location.search ? location.search : ""
        }${hash}`
      );
    }

    if (this.options.cookieName) {
      Cookie.set(`tabs_${this.options.cookieName}`, hash);
    }

    this.state.href = hash;
  }
  get href() {
    return this.state.href;
  }
  get $currentTab() {
    return this.$.tab.filter(".is-active");
  }
  get $currentLabel() {
    return this.$.label.filter(".is-active");
  }
  get $selectedLabel() {
    const $filtered = this.$.label.filter(`[href="${this.href}"]`);
    return $filtered.length ? $filtered : this.$.label.first();
  }
  get $selectedTab() {
    const $filtered = this.$.tab.filter((i, tab) => {
      return `#${tab.id}` === this.href;
    });

    return $filtered.length ? $filtered : this.$.tab.first();
  }
  fixHeight() {
    const height = this.$.section.outerHeight();
    this.$.section.height(height);
  }
  updateHeight() {
    const height = this.$currentTab.outerHeight();

    anime({
      targets: this.$.section.get(0),
      duration: 300,
      easing: "easeOutCubic",
      height,
      complete: () => {
        this.$.section.removeAttr("style");
      }
    });
  }
  destroy() {
    if (!this.state.init) return;

    this.$.label.off("click.tabs");
    this.$.label.off("keydown.tabs");

    delete this.state;

    return this;
  }
}

Component.mount(Tabs, {
  name: "Tabs",
  state: {
    init: false,
    href: location.hash || "",
    animating: false
  },
  classList
});
